import React from 'react';
import { Link } from 'react-router-dom';
import { Tooltip } from 'antd';
import styled from 'styled-components';
import { useTranslation } from '../../i18n/useTranslation';

const DeletedEntityName = styled.span`
    color: #8f9094;
    cursor: not-allowed;
`;

interface Props {
    name: string | null | undefined;
    to: string;
    exists?: boolean;
}

export const EntityNameLink = ({ name, to, exists }: Props) => {
    const { t } = useTranslation();

    if (!name) return <div>&ndash;</div>;

    /*
     * Deleted assets (exists === false — currently only datasets expose this flag) must not be
     * clickable, otherwise the entity page 404s. Render non-clickable, greyed-out text with a
     * tooltip, matching the old dashboard behaviour.
     */
    if (exists === false) {
        return (
            <Tooltip title={t('This dataset is no longer available.')}>
                <DeletedEntityName className="f-text-medium-content f-text-single-line f-text-semibold">
                    {name}
                </DeletedEntityName>
            </Tooltip>
        );
    }

    return (
        <Link
            role="button"
            className="f-text-medium-content f-text-single-line f-text-semibold f-color-dark-black-s100"
            to={to}
        >
            {name}
        </Link>
    );
};
